<script setup lang="ts">
defineProps<{
  title: string
  emptyMessage?: string
  items: any[]
}>()

defineEmits<{
  (e: 'add'): void
}>()
</script>

<template>
  <div class="flex flex-col gap-y-4">
    <BaseHeading
      tag="h3"
      size="lg"
      weight="medium"
    >
      {{ title }}
    </BaseHeading>

    <BaseMessage v-if="items.length === 0" type="info">
      {{ emptyMessage || `No ${title.toLowerCase()} added yet.` }}
    </BaseMessage>

    <div v-for="(_, index) in items" :key="index">
      <slot :index="index" />
    </div>

    <BaseButton color="primary" @click="$emit('add')">
      <slot name="add-button-text">
        Add item
      </slot>
    </BaseButton>
  </div>
</template>
